"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectTypeSuburbanSelectorOptions = exports.objectTypeSelectorOptionsCombined = exports.objectTypeFlatSelectorOptions = exports.objectTypeCommercialSelectorOptions = exports.objectToOfferMap = exports.EObjectTypeSuburban = exports.EObjectTypeFlat = exports.EObjectTypeCommercial = void 0;
var _types = require("../types");
var _offerTypeSelectorOptions = require("./offerTypeSelectorOptions");
/**
 * Взято из lead-realtor-form /v1/get-form
 * question: objectType{Flat|SuburbanWithLand|Commercial}
 * @see question.answers
 * */
let EObjectTypeFlat = exports.EObjectTypeFlat = /*#__PURE__*/function (EObjectTypeFlat) {
  EObjectTypeFlat["Flat"] = "flat";
  EObjectTypeFlat["Room"] = "room";
  return EObjectTypeFlat;
}({});
let EObjectTypeSuburban = exports.EObjectTypeSuburban = /*#__PURE__*/function (EObjectTypeSuburban) {
  EObjectTypeSuburban["House"] = "house";
  EObjectTypeSuburban["Cottage"] = "cottage";
  EObjectTypeSuburban["Townhouse"] = "townhouse";
  EObjectTypeSuburban["HouseShare"] = "houseShare";
  EObjectTypeSuburban["Land"] = "land";
  return EObjectTypeSuburban;
}({});
let EObjectTypeCommercial = exports.EObjectTypeCommercial = /*#__PURE__*/function (EObjectTypeCommercial) {
  EObjectTypeCommercial["Office"] = "office";
  EObjectTypeCommercial["ShoppingArea"] = "shoppingArea";
  EObjectTypeCommercial["FreeAppointmentObject"] = "freeAppointmentObject";
  EObjectTypeCommercial["Industry"] = "industry";
  EObjectTypeCommercial["Warehouse"] = "warehouse";
  EObjectTypeCommercial["Garage"] = "garage";
  EObjectTypeCommercial["CommercialLand"] = "commercialLand";
  return EObjectTypeCommercial;
}({});
const objectToOfferMap = exports.objectToOfferMap = {
  [EObjectTypeFlat.Flat]: _offerTypeSelectorOptions.EOfferType.Flat,
  [EObjectTypeFlat.Room]: _offerTypeSelectorOptions.EOfferType.Flat,
  [EObjectTypeSuburban.House]: _offerTypeSelectorOptions.EOfferType.Suburban,
  [EObjectTypeSuburban.Cottage]: _offerTypeSelectorOptions.EOfferType.Suburban,
  [EObjectTypeSuburban.Townhouse]: _offerTypeSelectorOptions.EOfferType.Suburban,
  [EObjectTypeSuburban.HouseShare]: _offerTypeSelectorOptions.EOfferType.Suburban,
  [EObjectTypeSuburban.Land]: _offerTypeSelectorOptions.EOfferType.Suburban,
  [EObjectTypeCommercial.Office]: _offerTypeSelectorOptions.EOfferType.Commercial,
  [EObjectTypeCommercial.ShoppingArea]: _offerTypeSelectorOptions.EOfferType.Commercial,
  [EObjectTypeCommercial.FreeAppointmentObject]: _offerTypeSelectorOptions.EOfferType.Commercial,
  [EObjectTypeCommercial.Industry]: _offerTypeSelectorOptions.EOfferType.Commercial,
  [EObjectTypeCommercial.Warehouse]: _offerTypeSelectorOptions.EOfferType.Commercial,
  [EObjectTypeCommercial.Garage]: _offerTypeSelectorOptions.EOfferType.Commercial,
  [EObjectTypeCommercial.CommercialLand]: _offerTypeSelectorOptions.EOfferType.Commercial
};
const objectTypeFlatSelectorOptions = exports.objectTypeFlatSelectorOptions = [{
  value: EObjectTypeFlat.Flat,
  selectedLabel: 'Квартира',
  label: 'Квартира'
}, {
  value: EObjectTypeFlat.Room,
  selectedLabel: 'Комната',
  label: 'Комната'
}];
const objectTypeSuburbanSelectorOptions = exports.objectTypeSuburbanSelectorOptions = [{
  value: EObjectTypeSuburban.House,
  selectedLabel: 'Дом/Дача',
  label: 'Дом/Дача'
}, {
  value: EObjectTypeSuburban.Cottage,
  selectedLabel: 'Коттедж',
  label: 'Коттедж'
}, {
  value: EObjectTypeSuburban.Townhouse,
  selectedLabel: 'Таунхаус',
  label: 'Таунхаус'
}, {
  value: EObjectTypeSuburban.HouseShare,
  selectedLabel: 'Часть дома',
  label: 'Часть дома'
}, {
  value: EObjectTypeSuburban.Land,
  selectedLabel: 'Участок',
  label: 'Участок'
}];
const objectTypeCommercialSelectorOptions = exports.objectTypeCommercialSelectorOptions = [{
  value: EObjectTypeCommercial.Office,
  selectedLabel: 'Офис',
  label: 'Офис'
}, {
  value: EObjectTypeCommercial.ShoppingArea,
  selectedLabel: 'Торговая площадь',
  label: 'Торговая площадь'
}, {
  value: EObjectTypeCommercial.FreeAppointmentObject,
  selectedLabel: 'Помещение свободного назначения',
  label: 'Помещение свободного назначения'
}, {
  value: EObjectTypeCommercial.Industry,
  selectedLabel: 'Производство',
  label: 'Производство'
}, {
  value: EObjectTypeCommercial.Warehouse,
  selectedLabel: 'Склад',
  label: 'Склад'
}, {
  value: EObjectTypeCommercial.Garage,
  selectedLabel: 'Гараж',
  label: 'Гараж'
}, {
  value: EObjectTypeCommercial.CommercialLand,
  selectedLabel: 'Коммерческая земля',
  label: 'Коммерческая земля'
}];
const objectTypeSelectorOptionsCombined = exports.objectTypeSelectorOptionsCombined = [...objectTypeFlatSelectorOptions, {
  value: _types.dropdownSeparator,
  selectedLabel: '',
  label: ''
}, ...objectTypeSuburbanSelectorOptions, {
  value: _types.dropdownSeparator,
  selectedLabel: '',
  label: ''
}, ...objectTypeCommercialSelectorOptions];